"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOMATION_MAX_RUNS_PER_DAY = exports.WORKFLOW_BILLING = void 0;
exports.workflowRunCreditsMicro = workflowRunCreditsMicro;
exports.automationCredits = automationCredits;
exports.automationMinimumCredits = automationMinimumCredits;
exports.automationRunsProjection = automationRunsProjection;
const schedule_1 = require("./schedule");
/**
 * How the platform bills a workflow run: its time in 30-second steps, each
 * started step at the rate of a minute of the plan (plan_configs
 * workflowCreditPerMinute; every plan uses this rate).
 */
exports.WORKFLOW_BILLING = {
    /** Billing granularity: 30 seconds. Credits are charged in 30s increments. */
    granularityMs: 30_000,
    /**
     * Credit cost per minute in micro-credits (1 Display Credit = 10,000 micro).
     * 1 Credit/min = 10,000 micro. "1 Credit = 1 Minute" — simple to communicate.
     */
    creditPerMinuteMicro: 10_000,
};
/** Micro-credits in one credit as people see it. */
const MICRO_PER_CREDIT = 10_000;
const DAY_MS = 24 * 60 * 60_000;
const DAYS_PER_MONTH = 30;
/**
 * The micro-credits a run of `durationMs` bills: every started step of
 * `granularityMs` at the rate of a minute.
 */
function workflowRunCreditsMicro(durationMs, creditPerMinuteMicro = exports.WORKFLOW_BILLING.creditPerMinuteMicro) {
    const steps = Math.ceil(durationMs / exports.WORKFLOW_BILLING.granularityMs);
    return ((steps * creditPerMinuteMicro * exports.WORKFLOW_BILLING.granularityMs) / 60_000);
}
/**
 * The credits of `runsPerDay` runs a day that bill `creditsMicroPerRun`
 * each, a day and in 30 days.
 */
function automationCredits(runsPerDay, creditsMicroPerRun) {
    const perDay = (runsPerDay * creditsMicroPerRun) / MICRO_PER_CREDIT;
    return { perDay, perMonth: perDay * DAYS_PER_MONTH };
}
/**
 * The least an automation started `runsPerDay` times a day costs: every run
 * bills at least one step, however short it is.
 */
function automationMinimumCredits(runsPerDay) {
    return automationCredits(runsPerDay, workflowRunCreditsMicro(1));
}
/**
 * What `runs` runs of an automation within `windowMs`, together
 * `creditsMicro`, come to a day and in 30 days at the same pace.
 */
function automationRunsProjection({ runs, creditsMicro, windowMs, }) {
    const runsPerDay = (runs * DAY_MS) / windowMs;
    const credits = automationCredits(runsPerDay, creditsMicro / runs);
    return {
        runsPerDay,
        creditsPerDay: credits.perDay,
        creditsPerMonth: credits.perMonth,
    };
}
/** The most runs a day of a schedule at the smallest interval. */
exports.AUTOMATION_MAX_RUNS_PER_DAY = DAY_MS / schedule_1.AUTOMATION_MIN_TICK_MS;
//# sourceMappingURL=billing.js.map